import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

const Privacy: React.FC = () => {
  const { t } = useTranslation()

  const sections = [
    { titleKey: 'privacySection1Title', contentKey: 'privacySection1Content' },
    { titleKey: 'privacySection2Title', contentKey: 'privacySection2Content' },
    { titleKey: 'privacySection3Title', contentKey: 'privacySection3Content' },
    { titleKey: 'privacySection4Title', contentKey: 'privacySection4Content' },
    { titleKey: 'privacySection5Title', contentKey: 'privacySection5Content' },
    { titleKey: 'privacySection6Title', contentKey: 'privacySection6Content' }
  ]

  return (
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl md:text-4xl font-bold text-apple-gray-900 mb-6">
          {t('privacyTitle')}
        </h1>
        
        <p className="text-apple-gray-500 text-sm mb-8">
          {t('privacyLastUpdated')}
        </p>

        <div className="prose prose-lg max-w-none">
          <p className="text-apple-gray-600 text-lg leading-relaxed mb-8">
            {t('privacyIntro')}
          </p>

          {sections.map((section, index) => (
            <motion.div
              key={section.titleKey}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="mb-8"
            >
              <h2 className="text-xl font-semibold text-apple-gray-900 mb-4">
                {t(section.titleKey)}
              </h2>
              <p className="text-apple-gray-600 leading-relaxed whitespace-pre-line">
                {t(section.contentKey)}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  )
}

export default Privacy




